import useError from 'modules/cm/hooks/useCaseStatus';

const useIsCaseStatue = (status: string) => {
  const state = useError();
  return state === status;
};

export default useIsCaseStatue;
